export default "__VITE_ASSET__DygQmFQr__"